/* eslint-disable */
import './emailSubscribeMin.css'
import SubscribeEmailFormView from './subscribeForm';

export default SubscribeEmailFormView;